class Sounds {
    ding() {
        return this.play("sound-ding", 0.4);
    }

    dong() {
        return this.play("sound-dong", 0.8);
    }

    dingdong() {
        return this.play("sound-dingdong");
    }

    timpani() {
        return this.play("sound-timpani", 0.8);
    }

    swip() {
        return this.play("sound-swip");
    }

    blast() {
        return this.play("sound-blast");
    }

    play(sound, volume = 0.5) {
        if (window.location.href.indexOf("/play") === -1) {
            sound = document.getElementById(sound);
            if (sound && sound.canPlayType('audio/mp3')) {
                try {
                    sound.volume = volume;
                    const playPromise = sound.play();
                    if (playPromise !== undefined) {
                        playPromise.then(_ => {
                        }).catch(error => {
                        });
                    }
                } catch (error) {
                }
            }
        }
    }
}